<template>
  <el-form ref="form.data" :rules="rulesForm" :model="form.data" class="form-cont">
    <div class="form-scroll">
      <div class="form-takeResa-cash" v-if="cashInfos">
        <i class="el-icon-info"></i>
        <span>Réservation avec {{ getCashTerme }} de {{ cashInfos.value }}€ par couvert, soit
          <b>{{ Math.round(cashInfos.value * this.getNbCouvert * 100) / 100 }} €.</b></span>
      </div>
      <div class="form-line">
        <el-form-item>
          <el-radio-group v-model="form.data.civ">
            <el-radio-button class="civ-m" label="M."></el-radio-button>
            <el-radio-button class="civ-f" label="Mme"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="name" class="full-width">
          <el-input v-model="form.data.name" placeholder="Nom*"></el-input>
        </el-form-item>
      </div>
      <el-form-item prop="prenom">
        <el-input v-model="form.data.prenom" placeholder="Prénom*"></el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input v-model="form.data.email" placeholder="e-mail*"></el-input>
      </el-form-item>
      <div class="form-line">
        <el-form-item prop="telPreFix" class="tel-prefix">
          <el-input v-model="form.data.telPreFix" placeholder="+33"></el-input>
        </el-form-item>
        <el-form-item prop="tel" class="tel full-width">
          <el-input v-model="form.data.tel" placeholder="Téléphone*"></el-input>
        </el-form-item>
      </div>
      <el-form-item>
        <el-input v-model="form.data.societe" placeholder="Société"></el-input>
      </el-form-item>

      <el-form-item>
        <el-input v-model="form.data.comment" :autosize="{ minRows: 3 }" type="textarea"
          placeholder="Ajouter un commentaire, une demande, etc..."></el-input>
      </el-form-item>
      <el-form-item prop="allergen">
        <el-checkbox v-model="form.data.allergen" @change="$refs['form.data'].clearValidate()">Intolérance /
          Allergie</el-checkbox>
      </el-form-item>
      <el-form-item v-if="form.data.allergen" prop="allergenMessage">
        <el-input v-model="form.data.allergenMessage" :autosize="{ minRows: 3 }" type="textarea"
          placeholder="Merci de renseigner les intolérances / allergies"></el-input>
      </el-form-item>
    </div>

    <el-skeleton :loading="cashInfos === undefined" animated class="booking-cont">
      <template slot="template">
        <el-skeleton-item class="booking-button-loading" animated />
      </template>
      <template>
        <el-button class="booking-button" @click="obSubmit()" :loading="sendIsLoading">
          Réserver
        </el-button>
      </template>
    </el-skeleton>
  </el-form>
</template>

<script>
import { Notification } from 'element-ui'
import uuidv4 from 'uuid/v4'
import { mapActions, mapGetters } from 'vuex'
import router from '../../router'
import * as resaState from '../../store/types/resa-state'
import { ERequestType, fetchPostHelper, fetchPutHelper } from '../../tools/fetch'
import { fetchCheckout, fetchCheckoutPAuto } from '../../tools/fetchHelper'
import { sendResaConfirmedMessage, sendResaPreConfirmedMessage, sendResaTakedRestaurateur, sendResaToConfirmRestaurateur } from '../../tools/messageSender'
import { readRwg } from '../../tools/rwg'
import { dateToTimeStamp, formatTimeH, parseTime } from '../../tools/timeTool'
import { checkPhone, validatePrefix } from '../../tools/validator'

export default {
  name: 'FormForkBooking',
  data() {
    return {
      form: {
        data: {
          civ: 'M.',
          name: '',
          prenom: '',
          email: '',
          telPreFix: '+33',
          tel: '',
          societe: '',
          comment: '',
          allergen: false,
          allergenMessage: ''
        }
      },
      cashInfos: undefined,
      rulesForm: {},
      sendIsLoading: false
    }
  },
  computed: {
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos',
      getSelectedDateTs: 'forkBooking/getSelectedDateTs',
      getNbCouvert: 'forkBooking/getNbCouvert',
      getSelectedService: 'forkBooking/getSelectedService',
      getSelectedDateObject: 'forkBooking/getSelectedDateObject'
    }),
    isIframe() {
      return this.$route.meta.isIframe
    },
    getCashTerme: function () {
      if (this.cashInfos && this.cashInfos.type && this.cashInfos.type === 'caution') return 'empreinte bancaire'
      else if (this.cashInfos && this.cashInfos.type && this.cashInfos.type === 'prepaiement') return 'prépaiement'
      return this.cashInfos.type
    }
  },
  methods: {
    ...mapActions({
      bookingClientProcess: 'newClients/bookingClientProcess',
      updateClient: 'newClients/updateClient',
      setCurrentStep: 'forkBooking/setCurrentStep',
      checkExistCashDays: 'cash/checkExistCashDays'
    }),
    loadStripeCheckout: (callback) => {
      let e = document.createElement('script')
      e.src = 'https://js.stripe.com/v3/'
      e.type = 'text/javascript'
      document.getElementsByTagName('head')[0].appendChild(e)
      e.addEventListener('load', callback)
    },
    async sendRwgConversion() {
      var stored = readRwg(this.$router.currentRoute.params.id);
      if (!stored.token) return;

      await fetchPostHelper(ERequestType.GOOGLE.POST_CONVERSION, {
        rwg_token: decodeURIComponent(stored.token),
        merchant_changed: "2",
      })
    },

    async fetchCashInfos() {
      const cashDayInfos = await this.checkExistCashDays({
        restoid: this.$router.currentRoute.params.id,
        ts: this.getSelectedDateTs,
        service: this.getSelectedService.serviceName
      })
      if (cashDayInfos && (!cashDayInfos.nbCouv || parseInt(cashDayInfos.nbCouv) <= parseInt(this.getNbCouvert))) {
        this.cashInfos = {
          type: cashDayInfos.type,
          value: cashDayInfos.value,
          nbCouv: cashDayInfos.nbCouv
        }
        return
      } else if (this.getSelectedService && this.getSelectedService.cashOn && (!this.getSelectedService.cashCouv || parseInt(this.getSelectedService.cashCouv) <= parseInt(this.getNbCouvert))) {
        this.cashInfos = {
          type: this.getSelectedService.cashType,
          value: this.getSelectedService.cashPrice,
          nbCouv: this.getSelectedService.cashCouv
        }
        return
      }
      this.cashInfos = null
    },
    getSessionDescription(client) {
      return `${this.getAllInfos.restoName} - ${this.form.data.civ} ${this.form.data.name} ${this.form.data.prenom} - tel : ${this.form.data.tel} - email : ${this.form.data.email} - service : ${this.getSelectedService.serviceName} - le : ${this.getSelectedDateObject.labelDay} ${this.getSelectedDateObject.label} ${this.getSelectedDateObject.month} ${this.getSelectedDateObject.year} à ${this.getSelectedService.hour}`
    },
    async obSubmit() {
      await this.$refs['form.data'].validate((valid) => {
        if (!valid) return
        if (this.$router.currentRoute.name === 'google-external') {
          this.sendRwgConversion()
        }
        this.onSubmitResa()
      })
    },
    async onSubmitResa() {
      this.sendIsLoading = true
      this.sendIsLoading = true
      const client = await this.bookingClientProcess({
        restoid: this.$router.currentRoute.params.id,
        cid: this.form.cid,
        clientPreFix: '',
        name: this.form.data.name,
        prenom: this.form.data.prenom,
        telPreFix: this.form.data.telPreFix,
        tel: this.form.data.tel,
        email: this.form.data.email,
        civ: this.form.data.civ,
        societe: this.form.data.societe
      })
      this.updateClient(client)
      if (this.cashInfos) {
        this.sendCashResa(client)
      } else {
        this.sendResaData(client)
      }
    },
    async sendCashResa(client) {
      const source = (router.currentRoute.name === 'site web') ? 'web' : router.currentRoute.name
      let newCashResa = {
        restoid: router.currentRoute.params.id,
        ts: this.getSelectedDateTs,
        service: this.getSelectedService.serviceName,
        type: this.cashInfos.type,
        couverts: this.getNbCouvert,
        amount: this.cashInfos.value,
        total: Math.round((parseFloat(this.getNbCouvert) * parseFloat(this.cashInfos.value)) * 100) / 100,
        hour: this.getSelectedService.hour,
        discount: this.getSelectedService.discount,
        cid: client.cid,
        date: this.getSelectedDateObject,
        comment: this.form.data.comment,
        allergen: this.form.data.allergen,
        allergenMessage: this.form.data.allergenMessage,
        stripeid: '',
        setupid: '',
        paidid: '',
        source,
        taked: false
      }
      const createdCashResas = await fetchPostHelper(ERequestType.CASHRESAS.CREATE, newCashResa)
      const isAutoAccept = this.getAllInfos.restoAutoAcceptPrepaiement && this.cashInfos.type === 'prepaiement'
      const redirect = this.getAllInfos.restoResaRedirect && this.getAllInfos.restoResaRedirectTxt !== '' ? this.getAllInfos.restoResaRedirectTxt : null
      const checkoutProcess = isAutoAccept
        ? await fetchCheckoutPAuto(
          router.currentRoute.params.id,
          this.getAllInfos.restoName,
          this.cashInfos.type,
          this.cashInfos.value * 100,
          this.getNbCouvert,
          source,
          createdCashResas.data.id,
          client.email,
          `${client.name} ${client.prenom}`,
          `${this.getAllInfos.restoName}-${this.form.data.civ} ${this.form.data.name} ${this.form.data.prenom} - tel : ${this.form.data.tel} - email : ${this.form.data.email} - service : ${this.getSelectedService.serviceName} - le : ${this.getSelectedDateObject.labelDay} ${this.getSelectedDateObject.label} ${this.getSelectedDateObject.month} ${this.getSelectedDateObject.year} à ${this.getSelectedService.hour}`,
          redirect
        )
        : await fetchCheckout(
          router.currentRoute.params.id,
          this.getAllInfos.restoName,
          this.cashInfos.type,
          this.cashInfos.value * 100,
          this.getNbCouvert,
          source,
          createdCashResas.data.id,
          client.email,
          `${client.name} ${client.prenom}`
        )

      if (isAutoAccept) {
        newCashResa.paidid = checkoutProcess.session.payment_intent
      } else {
        newCashResa.setupid = checkoutProcess.session.setup_intent
      }
      newCashResa.stripeid = checkoutProcess.session.id
      newCashResa.id = createdCashResas.data.id

      await fetchPutHelper(ERequestType.CASHRESAS.UPDATE, newCashResa)

      this.loadStripeCheckout(() => {
        try {
          let stripe = window.Stripe(import.meta.env.VITE_PK_STRIPE)
          stripe.redirectToCheckout({
            sessionId: checkoutProcess.session.id
          })
        } catch (e) {
          console.error(e)
          this.$emit('error', e)
        } finally {
          this.$emit('loading', false)
        }
      })
    },
    async sendResaData(client) {
      let resaData = {
        id: uuidv4(),
        ts: this.getSelectedDateTs,
        restoid: router.currentRoute.params.id,
        cid: client.cid,
        nbCouvert: this.getNbCouvert,
        hour: this.getSelectedService.hour,
        discount: this.getSelectedService.discount,
        dateResa: this.getSelectedDateObject,
        dateBooking: new Date(),
        room: '',
        tids: [],
        source: router.currentRoute.name,
        ms: this.getSelectedService.serviceName,
        subs: this.getSelectedService.serviceName,
        commentResa: this.form.data.comment,
        allergen: this.form.data.allergen,
        allergenMessage: this.form.data.allergenMessage,
        modifyBy: 'CLIENT',
        state: this.getAllInfos.restoAutoAccept ? resaState.CONFIRMED : resaState.TO_CONFIRM
      }

      const resaTaked = await fetchPostHelper(ERequestType.RESAS.CREATE, resaData).catch(err => {
        console.error(err)
        Notification.error({
          title: 'Error',
          message: err.message,
          position: 'bottom-right'
        })
      })

      Notification.success({
        title: 'Demande envoyée',
        message: 'Votre demande de réservation est envoyée au restaurateur. ',
        position: 'bottom-right'
      })

      const hourFormatted = formatTimeH(parseTime(this.getSelectedService.hour))
      const host = `http://${window.location.hostname}`
      const ts = dateToTimeStamp(resaData.dateResa.day, resaData.dateResa.month - 1, resaData.dateResa.year)
      const dateFormatted = `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`
      const clientName = `${client.name} ${client.prenom}`
      const clientEmail = client.email
      const restoName = this.getAllInfos.restoName
      const restoMail = this.getAllInfos.restoMail
      const resaFirstMessage = this.getAllInfos.resaFirstMessage
      const nbCouvert = resaTaked.data.nbCouvert
      const restoAdresse = this.getAllInfos.restoAdresse
      const restoTel = this.getAllInfos.restoTel
      const type = resaTaked.data.type
      const total = resaTaked.data.total
      const isAutoAccept = this.getAllInfos.restoAutoAccept
      const discount = resaTaked.data.discount
      const clientTel = this.form.data.tel
      const clientTelPreFix = this.form.data.telPreFix
      const sendSms = !!this.getAllInfos.clientSmsSended
      const sendResaRestaurateur = this.getAllInfos.restoMailSended === undefined || !this.getAllInfos.restoMailSended

      if (isAutoAccept) {
        const link = `${host}/change/${resaData.restoid.toString()}/${ts.toString()}/${resaData.id.toString()}`
        sendResaConfirmedMessage({
          clientName,
          clientEmail,
          restoName,
          restoEmail: restoMail,
          dateResa: dateFormatted,
          hourResa: hourFormatted,
          message: resaFirstMessage,
          nbCouverts: nbCouvert,
          adresse: restoAdresse,
          tel: restoTel,
          url: link,
          type,
          total,
          restoid: this.getAllInfos.restoid,
          discount,
          sendSms,
          clientTel,
          clientTelPreFix
        })

        if (!sendResaRestaurateur) {
          sendResaTakedRestaurateur({
            clientName,
            clientEmail,
            restoName,
            restoEmail: restoMail,
            dateResa: dateFormatted,
            hourResa: hourFormatted,
            message: resaFirstMessage,
            nbCouverts: nbCouvert,
            adresse: restoAdresse,
            tel: restoTel,
            source: resaTaked.data.source,
            discount
          })
        }
      } else {
        sendResaPreConfirmedMessage({
          clientName,
          clientEmail,
          restoName,
          restoEmail: restoMail,
          dateResa: dateFormatted,
          hourResa: hourFormatted,
          message: resaFirstMessage,
          nbCouverts: nbCouvert,
          adresse: restoAdresse,
          tel: restoTel,
          type,
          total,
          discount,
          sendSms,
          clientTel,
          clientTelPreFix,
          restoid: this.getAllInfos.restoid
        })
        if (!sendResaRestaurateur) {
          sendResaToConfirmRestaurateur({
            clientName,
            clientEmail,
            clientTel,
            restoName,
            restoEmail: restoMail,
            dateResa: dateFormatted,
            hourResa: hourFormatted,
            message: resaFirstMessage,
            nbCouverts: nbCouvert,
            adresse: restoAdresse,
            tel: restoTel,
            source: resaTaked.data.source,
            discount
          })
        }
      }

      if (this.getAllInfos.restoResaRedirect && this.getAllInfos.restoResaRedirectTxt !== '') {
        if (this.isIframe) {
          window.open(this.getAllInfos.restoResaRedirectTxt, '_blank')
        } else {
          window.location.replace(this.getAllInfos.restoResaRedirectTxt)
        }
      }
      this.setCurrentStep(4)
    }
  },
  created: function () {
    this.rulesForm = {
      email: [
        { required: true, message: 'Merci de rentrer une adresse e-mail', trigger: 'blur' },
        { type: 'email', message: 'Merci de rentrer une adresse e-mail valide', trigger: 'blur' }
      ],
      name: [
        { required: true, message: 'Merci de rentrer un nom', trigger: 'blur' }
      ],
      prenom: [
        { required: true, message: 'Merci de rentrer un prénom', trigger: 'blur' }
      ],
      tel: [
        { validator: checkPhone, trigger: 'blur' },
        { required: true, message: 'Merci de rentrer un téléphone', trigger: 'blur' }
      ],
      telPreFix: [
        { validator: (rule, value, callback) => validatePrefix(rule, value, callback, this.form.data.tel), trigger: 'blur' },
        { required: true, message: 'Invalide', trigger: 'blur' }
      ]
    }
  },
  mounted() {
    this.fetchCashInfos()
  }
}
</script>

<style lang="scss">
.form-cont {
  height: calc(100% - 73px);

  .form-scroll {
    overflow-y: auto;
    padding: 16px 16px 0px 16px;
    height: calc(100% - 89px);
  }

  .booking-cont {
    border-top: 1px solid var(--color-border);
    padding: 16px;
  }

  .civ-m {
    border-radius: 50px 0px 0px 50px !important;

    span {
      width: 60px;
      border-radius: 50px 0px 0px 50px !important;
      padding: 12px 0px 12px 4px;
    }
  }

  .civ-f {
    border-radius: 0px 50px 50px 0px !important;

    span {
      width: 60px;
      border-radius: 0px 50px 50px 0px !important;
      padding: 12px 0px;
    }

    margin-right: 8px;
  }

  input {
    border-radius: 50px;
  }

  .el-form-item {
    margin-bottom: 16px;
  }

  .el-form-item__error {
    padding-top: 0px;
    padding-left: 15px;
  }

  .el-collapse {
    margin-bottom: 16px;
  }

  .el-textarea textarea {
    resize: none;
    border-radius: 20px;
  }

  .booking-button {
    width: 100%;
    border-radius: 50px;

    &-loading {
      border-radius: 50px;
      height: 40px;
    }
  }

  .el-form-item__content {
    line-height: normal;
  }

  .el-collapse-item__content {
    padding-bottom: 0px;
  }

  .form-takeResa-cash {
    white-space: pre-line;
    margin-bottom: 16px;
    padding: 8px;
    border-radius: 20px;

    &-text {
      font-size: 14px;
    }
  }

  .form-line {
    display: flex;
    justify-content: space-between;

    .full-width {
      flex: 1;
    }

    .tel-prefix {
      width: 80px;

      input {
        border-radius: 50px 0px 0px 50px;
        border-right: 0px;
      }
    }

    .tel {
      input {
        border-radius: 0px 50px 50px 0px;
      }
    }
  }
}
</style>